var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon2X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9297",
    "data-name": "Rectangle 9297",
    width: 68,
    height: 68,
    transform: "translate(-0.245 -0.245)",
    fill: "#111929"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34002",
    "data-name": "Group 34002",
    transform: "translate(0.245 0.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31090",
    "data-name": "Group 31090",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67961",
    "data-name": "Path 67961",
    d: "M57.991,67.51H9.521A9.532,9.532,0,0,1,0,57.988V9.521A9.532,9.532,0,0,1,9.521,0H57.991A9.532,9.532,0,0,1,67.51,9.521V57.988a9.532,9.532,0,0,1-9.519,9.521M9.521,5.193A4.334,4.334,0,0,0,5.193,9.521V57.988a4.334,4.334,0,0,0,4.328,4.328H57.991a4.332,4.332,0,0,0,4.326-4.328V9.521a4.332,4.332,0,0,0-4.326-4.328Z",
    fill: "#111929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67962",
    "data-name": "Path 67962",
    d: "M23.983,22.792A9.318,9.318,0,1,1,33.3,13.473a9.327,9.327,0,0,1-9.316,9.319m0-13.442a4.125,4.125,0,1,0,4.123,4.123A4.127,4.127,0,0,0,23.983,9.35",
    transform: "translate(23.416 6.637)",
    fill: "#111929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67963",
    "data-name": "Path 67963",
    d: "M57.989,50.06a2.589,2.589,0,0,1-1.836-.761L25.148,18.294a7.592,7.592,0,0,0-10.482,0L4.433,28.527A2.6,2.6,0,0,1,.761,24.855L10.994,14.622a12.6,12.6,0,0,1,17.825,0L59.824,45.627a2.6,2.6,0,0,1-1.836,4.432",
    transform: "translate(0 17.45)",
    fill: "#111929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon2X);
export default __webpack_public_path__ + "static/media/edit-icon-2x.9b12e561fe245a263796efe6de73dbf5.svg";
export { ForwardRef as ReactComponent };